import { some } from 'fp-ts/lib/Option';
import { ReactNode } from 'react';
import { Feature, FeatureViewDefault } from '../../source';
import { getAlias } from '../../app';
import { getFeatureProperties } from '../../util';
import { DIV, NODISPLAY, TD } from '../elements';
import { elementFactoryRow, NotNullProperties } from './helpers';

const renderTableRow = (props: NotNullProperties, k: string) =>
    TD('', `${props[k]}`);

export const renderRow =
    (props: NotNullProperties, metadataId: string, asTableRow: boolean) =>
    (k: string) => {
        if (asTableRow) {
            return renderTableRow(props, k);
        }
        const className = 'feature-field';
        const key = `feature-field-${k}`;

        if (!props[k]) {
            return NODISPLAY({ className, key });
        }

        const val = `${props[k]}`;

        return DIV(
            { className, key },
            DIV('feature-field-label', getAlias(k, some(metadataId))),
            DIV('feature-field-value', val)
        );
    };

export const renderDefault = (
    feature: Feature,
    options: FeatureViewDefault,
    metadataId: string,
    asTableRow: boolean
) => {
    const lines: ReactNode[] = [];
    const ROW = elementFactoryRow(asTableRow);
    if (feature) {
        const props = getFeatureProperties(feature);
        const keys = options.keys ?? Object.keys(feature.properties ?? {});
        if (props) {
            return ROW(
                'feature-view config',
                keys.map(renderRow(props, metadataId, asTableRow))
            );
        }
    }
    return ROW('feature-view default', ...lines);
};

export default renderDefault;
